import React from "react";
import BottomServiceBanner from "../../../components/ServiceBanner/BottomServiceBanner";
import TopServiceBanner from "../../../components/ServiceBanner/TopServiceBanner";
import "./trx.css";
import { MdLocationPin } from "react-icons/md";
import { MdOutlineEmail } from "react-icons/md";
import { BiPhoneCall } from "react-icons/bi";
import banner from "../../../assets/images/banner/trasferrx.png"
import BottomBanner from "../../../components/ServiceBanner/BottomBanner";

// import Aos from 'aos';
// import 'aos/dist/aos.css';
// import { useEffect } from "react";

const Trx = () => {

  // useEffect(() => {
  //   Aos.init({duration: 2000});
  // }, []);

  return (
    <div className="transferrx-container">
      <TopServiceBanner title="Transfer-RX" banner={banner}/>
      <div className="trx-container">
        <div className="transferrx-container-maintitle">
          A FULL-SERVICE PHARMACY DELIVERING BETTER AND SIMPLE EXPERIENCE!
        </div>
        <div className="transferrx-container-maindesc">
          We have made transferring your prescriptions to florida Pharmacy
          quicker and easier! Simply fill in the form below and we will get the
          transfer process started as quickly as possible. Prescription
          transfers generally only take one to two business days and we aim to
          have your prescription transferred within 24 hours!
        </div>
      </div>
      <div className="transferrx-container-form">
        <div className="transferrx-container-form-top">
          <h3 className="transferrx-container-form-top-title">
            FOR QUERIES, FEEL FREE TO CONTACT US AT:
          </h3>
          <div className="transferrx-container-form-top-text">
            <div className="transferrx-container-form-top-text-top">
              <BiPhoneCall className="transferrx-container-form-top-icon" />
              info@lincourtpharmacy
            </div>
            <div className="transferrx-container-form-top-text-top">
              <MdOutlineEmail className="transferrx-container-form-top-icon" />
              (727) 447-4248
            </div>
          </div>
          <h3 className="transferrx-container-form-top-title">VISIT US AT:</h3>
          <div className="transferrx-container-form-top-text-bottom">
            <MdLocationPin className="transferrx-container-form-top-icon " />
            501 S Lincoln Ave. Clearwater, FL 33756
          </div>
        </div>
        <form className="transferrx-container-form-bottom-container">
          <div className="transferrx-container-form-bottom">
            <div className="transferrx-container-form-bottom-left">
              <div className="transferrx-container-form-bottom-title-container">
                PERSONAL INFORMATION
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Full Name
                <input type="text" placeholder="Full Name" />
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Email
                <input type="text" placeholder="Email Address" />
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Phone
                <input type="text" placeholder="Phone Number" />
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Date Of Birth
                <input type="text" placeholder="DD/MM/YYYY" />
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Address
                <input type="text" placeholder="Address" />
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                City
                <input type="text" placeholder="City" />
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                State
                <input type="text" placeholder="State" />
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Zip Code
                <input type="text" placeholder="Zip Code" />
              </div>
            </div>
            <div className="transferrx-container-form-bottom-right">
              <div className="transferrx-container-form-bottom-title-container">
                PRESCRIPTION INFORMATION
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Current Pharmacy
                <input type="text" placeholder="Current " />
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Pharmacy Number
                <input type="text" placeholder="Pharmacy No." />
              </div>
              <div className="transferrx-container-form-bottom-radio-container">
                Transfer all current prescriptions?
                <div className="transferrx-container-form-bottom-radio-container-inner">
                  <input type="radio" />
                  <label for="yes">Yes</label>
                </div>
                <div className="transferrx-container-form-bottom-radio-container-inner">
                  <input type="radio" />
                  <label for="no">No</label>
                </div>
              </div>
              <div className="transferrx-container-form-bottom-input-container">
                Prescription Number
                <input type="text" placeholder="Prescription No." />
              </div>
              <div className="transferrx-container-form-bottom-textarea-container">
                Additional Info.
                <textarea
                  className=""
                  name="Additional Info."
                  placeholder="Your Requirement"
                  cols="38"
                  rows="9"
                ></textarea>
              </div>
            </div>
          </div>
          <div className="transferrx-container-form-bottom-button-container">
          <button className="transferrx-container-form-bottom-button">Submit</button>
          </div>
        </form>
      </div>
      <div className="trx-container">
        <div className="transferrx-container-maintitle">
        WE MAKE PRESCRIPTION TRANSFER EASIER
        </div>
        <div className="transferrx-container-maindesc">
        With Florida Pharmacy, managing your prescription is simple, from start to finish. Just follow a few steps mentioned above to transfer or refill your prescription online. But, if you are not comfortable in providing the information that has been requested in this form then we are glad to initiate your transfer process over phone or in person at the florida Pharmacy.
        </div>
      </div>
      <BottomServiceBanner />
      <BottomBanner />

    </div>
  );
};

export default Trx;
